import axios from './HTTP'

export default {
  getUnreadCount (callback, errorCallback) {
    axios
      .get('/api/messages/unread_count.json')
      .then(response => ( callback(response.data) ))
      .catch(err => {
        errorCallback(err)
      })
  },

  getUnreadRequestCount (callback, errorCallback) {
    axios
      .get('/api/messages/unread_request_count.json')
      .then(response => ( callback(response.data) ))
      .catch(err => {
        errorCallback(err)
      })
  },

  getInbox (params, callback, errorCallback) {
    axios
      .get('/api/messages.json', { params })
      .then(response => ( callback(response.data) ))
      .catch(error => {
        errorCallback(error)
      })
  },

  searchInbox (params, callback, errorCallback) {
    axios
      .get('/api/messages.json', { params })
      .then(response => ( callback(response.data) ))
      .catch(error => {
        errorCallback(error)
      })
  },

  getRequests (params, callback, errorCallback) {
    axios
      .get('/api/messages/requests.json', { params })
      .then(response => ( callback(response.data) ))
      .catch(error => {
        errorCallback(error)
      })
  },

  searchRequests (params, callback, errorCallback) {
    axios
      .get('/api/messages/requests.json', { params })
      .then(response => ( callback(response.data) ))
      .catch(error => {
        errorCallback(error)
      })
  },

  getOutbox (params, callback, errorCallback) {
    axios
      .get('/api/messages/outbox.json')
      .then(response => ( callback(response.data) ))
      .catch(error => {
        errorCallback(error)
      })
  },

  searchOutbox (params, callback, errorCallback) {
    axios
      .get('/api/messages/outbox.json', { params })
      .then(response => ( callback(response.data) ))
      .catch(error => {
        errorCallback(error)
      })
  },


  getArchive (params, callback, errorCallback) {
    axios
      .get('/api/messages_archive.json', { params })
      .then(response => ( callback(response.data) ))
      .catch(error => {
        errorCallback(error)
      })
  },

  searchArchive (params, callback, errorCallback) {
    axios
      .get('/api/messages_archive.json', { params })
      .then(response => ( callback(response.data) ))
      .catch(error => {
        errorCallback(error)
      })
  },

  create (messageParams, callback, errorCallback) {
    axios
      .post('/api/messages.json',
        { message: {
            in_reply_to_message_id: messageParams.inReplyToMessageId,
            sender_id: messageParams.senderId,
            recipient_ids: messageParams.recipientIds,
            subject: messageParams.subject,
            message: messageParams.message,
          },
          options: {
            copy_sms: messageParams.copySMS
          }
        }
      ).then(response => {
        callback(response.data)
      })
      .catch(error => {
        errorCallback(error)
      })
  },

  getRecipientName (userId, callback, errorCallback) {
    axios
      .get(`/api/message_recipients/${ userId }.json`)
      .then(res => {
        callback(res.data)
      })
      .catch(error => {
        errorCallback(error)
      })
  },

  getEmployeeRecipients (callback, errorCallback) {
    axios
      .get(`/api/messages/employee_recipients.json`)
      .then(res => {
        callback(res.data)
      })
      .catch(error => {
        errorCallback(error)
      })
  },

  sendShiftIniquiry (messageParams, callback, errorCallback) {
    axios
      .post('/api/shift_inquiries.json',
        {
          shift_id: messageParams.shiftId,
          sender_id: messageParams.senderId,
          recipient_ids: messageParams.recipientIds,
          message: messageParams.message,
        }
      ).then(response => ( callback(response.data) ))
      .catch(error => {
        errorCallback(error)
      })
  },

  createManagerMessage (messageParams, callback, errorCallback) {
    axios
      .post('/api/manager_messages.json',
        { message: {
            subject: messageParams.subject,
            message: messageParams.message,
          }
        }
      ).then(response => ( callback(response.data) ))
      .catch(error => {
        errorCallback(error)
      })
  },

  getGroupedRecipients (callback) {
    axios
      .get('/api/messages/possible_recipients.json')
      .then(response => ( callback(response.data) ))
      .catch(error => {
        errorCallback(error)
      })
  },

  markArchived (messageId, callback, errorCallback) {
    axios
      .patch(`/api/messages/${ messageId }/mark_archived.json`)
      .then(response => ( callback(response.data) ))
      .catch(error => {
        errorCallback(error)
      })
  },

  markInbox (messageId, callback, errorCallback) {
    axios
      .patch(`/api/messages/${ messageId }/mark_inbox.json`)
      .then(response => ( callback(response.data) ))
      .catch(error => {
        errorCallback(error)
      })
  },

  markRead (messageId, callback) {
    axios
      .patch(`/api/messages/${ messageId }/mark_read.json`)
      .then(response => ( callback(response.data) ))
      .catch(error => {
        errorCallback(error)
      })
  },

  markUnread (messageId, callback) {
    axios
      .patch(`/api/messages/${ messageId }/mark_unread.json`)
      .then(response => ( callback(response.data) ))
      .catch(error => {
        errorCallback(error)
      })
  },

  markFlagged (messageId, callback) {
    axios
      .patch(`/api/messages/${ messageId }/mark_flagged.json`)
      .then(response => ( callback(response.data) ))
      .catch(error => {
        errorCallback(error)
      })
  },

  markUnflagged (messageId, callback) {
    axios
      .patch(`/api/messages/${ messageId }/mark_unflagged.json`)
      .then(response => ( callback(response.data) ))
      .catch(error => {
        errorCallback(error)
      })
  },
}
